import Vue from 'vue';
import Iframe from '@/components/copyright/basics/iframeDialog/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaIframeDialog = vue.extend(Iframe)
    if (!$vm) {
      $vm = new TsaIframeDialog({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const iframe = {
      show (options = {}) {
        $vm.showHandle(options)
      },
      init (options = {}) {
        $vm.initHandle(options)
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaIframeDialog) {
      vue.prototype.$TsaIframeDialog = iframe
    }
  }
}
export default plugin